import { h, render, Fragment } from 'preact';
import { useMemo } from 'preact/hooks';
import Instagram from '../utils/icon/Instagram.svg';
import Facebook from '../utils/icon/fb.svg';
import Tiktok from '../utils/icon/tiktok.svg';
import Footermenu from './footer-menu';
import LanguageSelect from './lang-select';
import { liqTrackForm } from '../utils/helpers';
import './footer.css';

export default (element, data) => {
  const init = () => {
    render(<Footer />, element);
  };

  const Footer = () => {
    const klaviyoForm = useMemo(
      () => <div className={`klaviyo-form-${data.newsletterFormId}`}></div>,
      [data],
    );

    let time = 1000;

    const timer = setInterval(() => {
      const formWrap = document.querySelector(
        `.klaviyo-form-${data.newsletterFormId}`,
      );
      if (formWrap) {
        const form = formWrap.querySelector('form');

        if (form) {
          const submitForm = form.querySelector('button');
          clearInterval(timer);
          // eslint-disable-next-line consistent-return
          form.addEventListener('submit', (e) => liqTrackForm(e, form));
          submitForm.addEventListener('click', (e) => liqTrackForm(e, form));
        }
      }
      time += 1000;
      if (time > 20000) {
        clearInterval(timer);
      }
    }, 1000);

    return (
      <>
        <div
          className="laptop:px-10 laptop:grid-cols-12 laptop:grid flex flex-col"
          style={{ backgroundColor: data.footer_bg }}
        >
          <div className="px-[22px] col-span-3 pb-10 laptop:pb-8 flex flex-col justify-between items-start pt-10 laptop:pt-[70px] laptop:pl-0 laptop:pr-0">
            <div>
              <p className="subheading-h3 mb-2.5 laptop:mb-4 text-black">
                {data.newsletter_hading}
              </p>
              <p className="font-13 mb-4 text-black">
                {data.newsletter_content}
              </p>
              <div className="footer-form mb-[30px] laptop:mb-0">
                {klaviyoForm}
              </div>
            </div>
            <div className="flex items-start laptop:items-center justify-start flex-col laptop:flex-row gap-3 laptop:gap-6">
              <p className="font-14-bold text-black">
                {window.TMW?.Strings?.footer?.folow}
              </p>
              <ul className="flex gap-[21px] items-center justify-start">
                <li className="flex">
                  <a
                    href={data.instagram}
                    target={'_blank'}
                    className="link-unstyled"
                    rel="noreferrer"
                  >
                    <Instagram className="transition-all text-charcoal hover:text-black" />
                  </a>
                </li>
                <li className="flex">
                  <a
                    href={data.facebook}
                    target={'_blank'}
                    className="link-unstyled"
                    rel="noreferrer"
                  >
                    <Facebook className="transition-all text-charcoal hover:text-black" />
                  </a>
                </li>
                <li className="flex">
                  <a
                    href={data.tiktok}
                    target={'_blank'}
                    className="link-unstyled"
                    rel="noreferrer"
                  >
                    <Tiktok className="transition-all text-charcoal hover:text-black" />
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <LanguageSelect />
            </div>
          </div>
          <div className="laptop:pr-5 laptop:ml-10 col-span-9 pb-[38px] laptop:pl-[60px] laptop:pt-[70px] laptop:border laptop:border-r-0 laptop:border-t-0 laotop:border-b-0 border-black-30">
            <div className="flex justify-between items-start mb-6 laptop:mb-[28px] laptop:flex-row flex-col border border-l-0 border-r-0 border-b-0 border-black-30 laptop:border-0">
              {data.menus.map((menu, index) => (
                <Footermenu key={index} menu={menu} index={index + 1} />
              ))}
            </div>
            <div className="flex flex-col px-[21px] laptop:px-0 laptop:flex-row laptop:space-x-3">
              <div className="mb-[27px] laptop:mb-0 laptop:flex laptop:flex-auto">
                <ul className="flex items-center justify-center laptop:justify-start gap-4 desktop:gap-[30px] flex-wrap">
                  {data.privacy_policy_menu.map((link, index) => (
                    <li
                      className="laptop:flex laptop:justify-center"
                      key={index}
                    >
                      <a
                        href={link.title !== 'Accessibility' ? link.url : '#'}
                        className="whitespace-nowrap utility-2 text-black inline-block before:bottom-[-2px]"
                        data-acsb-custom-trigger={
                          link.title === 'Accessibility' ? 'true' : undefined
                        }
                      >
                        {link.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex laptop:flex-auto justify-center laptop:justify-end items-center laptop:text-right">
                <p className="utility-2 text-black-70 whitespace-nowrap">
                  {data.copyright}
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  init();
};
